import { render, staticRenderFns } from "./ProjectMy.vue?vue&type=template&id=86d0d1ca&"
import script from "./ProjectMy.vue?vue&type=script&lang=ts&"
export * from "./ProjectMy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports